export default __webpack_public_path__ + "static/referral-banner-1bda375ebe6f5606b317e0ef838af2aa.png";